// ─────────────────────────────────────────────────────────────────────────────
// SurvAIHealth EHR — access gate.
//
// The EHR app space is restricted to the SYSTEM ADMINISTRATOR only. A system
// admin is the "admin" role WITHOUT an organization_id (i.e. the platform owner,
// not a per-facility/per-org admin). The platform owner's email is also allowed
// explicitly as a belt-and-suspenders safeguard.
// ─────────────────────────────────────────────────────────────────────────────

// Platform owner / system administrator email(s). Lowercase — matched case-insensitively.
export const SYSTEM_ADMIN_EMAILS = [
  "andonware@gmail.com",
  "aware@survaihealth.com",
];

export function canViewEHR(session) {
  if (!session) return false;
  const email = (session.email || "").toLowerCase();
  if (SYSTEM_ADMIN_EMAILS.includes(email)) return true;
  // True system admin = admin role not scoped to a single organization.
  const isSystemAdmin =
    session.role === "admin" &&
    !session.organization_id &&
    !session.organizationId;
  return isSystemAdmin;
}
